<template>
    <div>
        <div class="loginBox">
            <img class="logoWrap" src="/static/images/logo.png" alt="seatup">
            <div class="innerLoginBox">
                <h1>{{ $t('loginTitle') }}</h1>
                <form action="#" method="post" @submit.prevent="submitLogin">
                    <div class="inputWrap">
                        <label for="loginEmail">
                            <svg class="i_email"><use xlink:href="#i_email"></use></svg>
                            <span>{{ $t('email') }}</span>
                        </label>
                        <input type="email" id="loginEmail" name="loginEmail" v-model="email" required>
                    </div>
                    <div class="inputWrap">
                        <label for="loginPassword">
                            <svg class="i_lock"><use xlink:href="#i_lock"></use></svg>
                            <span>{{ $t('password') }}</span>
                        </label>
                        <input type="password" id="loginPassword" name="loginPassword" v-model="password" required>
                    </div>
                    <div class="inputWrap submitWrap">
                        <button>
                            <span>{{ $t('login') }}</span>
                        </button>
                    </div>
                    <router-link to="/login/recover" class="loginBtn">{{ $t('forgotPw') }}</router-link>
                </form>
            </div>
        </div>
        <div class="langBox">
            <a v-for="lang of this.$t('langs')" href="#" v-bind:class="$store.state.preferences.lang == lang.code ? 'active' : ''" @click.prevent="saveLang(lang.code)">{{ lang.code }}</a>
        </div>
        <Keyboard></Keyboard>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Keyboard from './Keyboard'
    export default {
        name: "KioskLogin",
        data() {
            return {
                email:'',
                password:'',
                opacity:0,
            }
        },
        components:{
            Keyboard
        },
        methods:{
            saveLang(langCode){
                Vue.i18n.set(langCode);
                this.$store.dispatch('saveLang',langCode)
            },
            submitLogin(e){
                this.$store.dispatch('makeLogin', {email:$("#loginEmail").val(),password:$("#loginPassword").val()})
                    .then(response => {
                        this.$router.push('/')
                    })
                    .catch(response => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('invalidLogin'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            }
        }
    }
</script>

<style>
    /*body{
        min-height:calc(100% + 140px)
    }*/
    @media only screen and (max-width:900px) and (max-height:1600px) {
        main.kioskCompLogin {
            background: #000000 url('/static/images/kioskBg.png') center center no-repeat !important;
            width: 100% !important;
            min-height: 100% !important;
            padding: 90px 70px !important;
            position: relative !important;
            background-size: cover !important;
        }

        main.kioskCompLogin:before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            right: 0 !important;
            width: 100% !important;
            height: 100% !important;
            background: rgba(29, 32, 62, 0.88) !important;
            background: -moz-linear-gradient(0deg, rgba(29, 32, 62, 0.88) 0%, rgba(255, 255, 255, 0) 100%) !important;
            background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(29, 32, 62, 0.88)), color-stop(100%, rgba(255, 255, 255, 0))) !important;
            background: -webkit-linear-gradient(180deg, rgba(29, 32, 62, 0.88) 0%, rgba(255, 255, 255, 0) 100%) !important;
            background: -o-linear-gradient(180deg, rgba(29, 32, 62, 0.88) 0%, rgba(255, 255, 255, 0) 100%) !important;
            background: -ms-linear-gradient(180deg, rgba(29, 32, 62, 0.88) 0%, rgba(255, 255, 255, 0) 100%) !important;
            background: linear-gradient(180deg, rgba(29, 32, 62, 0.88) 0%, rgba(255, 255, 255, 0) 100%) !important;
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#1d203e', endColorstr='#ffffff', GradientType=1) !important;
        }
        .kioskCompLogin .loginBox .logoWrap{
            width:217px;
            margin:0 auto 110px;
            display: block;
            position: relative;
        }
        .kioskCompLogin .innerLoginBox{
            position: relative;
            text-align: center;
        }
        .kioskCompLogin .innerLoginBox h1{
            font-weight:300;
            color:#fff;
            font-size:75px;
            position: relative;
            line-height: 155px;
            display: inline-block;
        }
        .kioskCompLogin .innerLoginBox h1:before{
            content: "";
            background: #fff;
            position: absolute;
            bottom:100%;
            right:10%;
            width: 80%;
            height:3px;
        }
        .kioskCompLogin .innerLoginBox h1:after{
            content: "";
            background: #fff;
            position: absolute;
            top:100%;
            right:20%;
            width: 60%;
            height:5px;
        }
        .kioskCompLogin .innerLoginBox form{
            margin: 120px auto 0;
            width: 70%;

        }
        .kioskCompLogin .innerLoginBox form svg.i_email{
            fill:#fff;
            width:34px;
            height:26px;
        }
        .kioskCompLogin .innerLoginBox form svg.i_lock{
            fill:#fff;
            width:28px;
            height:42px;
        }
        .kioskCompLogin .inputWrap label span{
            font-size: 31px;
        }
        .kioskCompLogin .inputWrap input{
            height: 100px;
            border-radius: 49px;
            border-width: 2px;
            font-size: 31px;
            padding: 0 30px;
        }
        .kioskCompLogin .inputWrap label{
            margin-bottom: 22px;
        }
        .kioskCompLogin .inputWrap label svg{
            margin-left: 22px;
        }
        .kioskCompLogin .inputWrap + .inputWrap {
            margin-top: 50px;
        }
        .kioskCompLogin .inputWrap.submitWrap button{
            width: 100%;
            float: none;
            border: 2px solid #5cdad3;
            transition: all .25s ease-in-out;
            -moz-transition: all .25s ease-in-out;
            -webkit-transition: all .25s ease-in-out;
            font-size: 31px;
            height: 100px;
            border-radius: 49px;
            background: -moz-linear-gradient(0deg, rgba(123,150,196,1) 0%, rgba(85,228,212,1) 100%);
            background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(123,150,196,1)), color-stop(100%, rgba(85,228,212,1)));
            background: -webkit-linear-gradient(0deg, rgba(123,150,196,1) 0%, rgba(85,228,212,1) 100%);
            background: -o-linear-gradient(0deg, rgba(123,150,196,1) 0%, rgba(85,228,212,1) 100%);
            background: -ms-linear-gradient(0deg, rgba(123,150,196,1) 0%, rgba(85,228,212,1) 100%);
            background: linear-gradient(90deg, rgba(123,150,196,1) 0%, rgba(85,228,212,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7b96c4', endColorstr='#55e4d4',GradientType=1 );
        }
        .kioskCompLogin .loginBtn {
            display: inline-block;
            color: #fff;
            font-size: 31px;
            text-decoration: underline;
            margin-top: 45px;
            font-weight: 700;
            font-style: italic;
        }
        .kioskCompLogin .langBox{
            position: absolute;
            bottom: 90px;
            right: 70px;
            width: calc(100% - 140px);
            text-align: center;
        }
        .kioskCompLogin .langBox>a{
            width:75px;
            height:75px;
            border-radius: 50%;
            border:2px solid transparent;
            color:#fff;
            font-size: 25px;
            display: inline-block;
            line-height: 71px;
            text-transform: uppercase;

        }
        .kioskCompLogin .langBox>a.active{
            border:2px solid #fff;
            background: rgba(0,0,0,0.32);
        }
        .kioskCompLogin .langBox>a+a{
            margin-right:10px;
        }
        .kioskCompLogin #keyboard{
            width: 100%;
            position: fixed;
            bottom:0;
            right:0;
            background: rgba(29,32,62,0.73);

            height: 0;
        }
        .kioskCompLogin #keyboard.open{
            padding: 10px 0 20px;
            height: auto;
        }
        .kioskCompLogin .jkeyboard .jline .space{
            color:#77b2d0;
            font-size: 28px;
            font-weight: 700;
        }
    }

    /*ipad mini*/
    @media only screen and (max-width:769px) and (max-height: 1025px){
        .kioskCompLogin .innerLoginBox h1{
            font-size: 55px;
            line-height: 75px;
        }
        .kioskCompLogin .innerLoginBox form{
            margin: 25px auto 0;
        }
        .kioskCompLogin .inputWrap input{
            height:66px
        }
        .kioskCompLogin .langBox>a{
            width:45px;
            height:45px;
            line-height: 38px;
        }
        .kioskCompLogin .langBox{
            bottom: 20px;
        }
    }

</style>